import type { SectionCategoryEntry } from '../types';

export const MEDICAL_OFFICE_OPEN_CATEGORY_NAME_MAX_LENGTH = 60;

export const MEDICAL_OFFICE_DEFAULT_CATEGORY_CODE = 'HEIDI-BEFUND';

export const MEDICAL_OFFICE_GDT_SECTION_MAPPINGS: SectionCategoryEntry[] = [
  { fieldId: '6330', sectionName: 'Anamnese', categoryCode: 'HEIDI-ANAMNESE' },
  {
    fieldId: '6330',
    sectionName: 'Befund',
    categoryCode: MEDICAL_OFFICE_DEFAULT_CATEGORY_CODE,
  },
  { fieldId: '6330', sectionName: 'Therapie', categoryCode: 'HEIDI-THERAPIE' },
  { fieldId: '6330', sectionName: 'Procedere', categoryCode: 'HEIDI-PROCEDERE' },
];

const MEDICAL_OFFICE_PVS_SYSTEM_NAMES = ['Medical Office'] as const;

function normalisePvsName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '');
}

export function isMedicalOfficePvsSystemName(name?: string | null): boolean {
  if (!name) return false;
  const normalised = normalisePvsName(name);
  return MEDICAL_OFFICE_PVS_SYSTEM_NAMES.some(
    (pvsName) => normalisePvsName(pvsName) === normalised
  );
}

export function getMedicalOfficeDefaultGdtSectionMappings(): SectionCategoryEntry[] {
  return MEDICAL_OFFICE_GDT_SECTION_MAPPINGS.map((entry) => ({ ...entry }));
}
